import * as config from '../app/config';

const MODULE = config.API_GATEWAY_URL + 'group/members/';

export const LIST_GROUP_MEMBERS_ENDPOINT = MODULE + "list";
export const GET_GROUP_MEMBER_ENDPOINT = MODULE + "get";
export const CREATE_GROUP_MEMBER_ENDPOINT = MODULE + "create";
export const REMOVE_GROUP_MEMBER_ENDPOINT = MODULE + "remove";
export const UDPATE_GROUP_MEMBER_ENDPOINT = MODULE + "update";
export const GROUP_MEMBER_LEAVE_ENDPOINT = MODULE + "leave";